module.exports = __webpack_public_path__ + "img/menu-icon.79158fe6.gif";